import PropTypes from 'prop-types'
import { compose, setDisplayName, withHandlers, withState, pure } from 'recompose'

import { DropdownView } from 'components/dropdown/dropdown/DropdownView'

const handlePopoverToggle =
  ({ setIsOpen, onClose }) =>
  () => {
    setIsOpen(isOpen => {
      if (isOpen && onClose) {
        onClose()
      }

      return !isOpen
    })
  }

export const Dropdown = compose(
  setDisplayName('Dropdown'),
  pure,
  withState('isOpen', 'setIsOpen', false),
  withState('containerRef', 'setContainerRef', null),
  withHandlers({
    handlePopoverToggle,
  }),
)(DropdownView)

Dropdown.propTypes = {
  // container
  onClose: PropTypes.func,

  // view
  children: PropTypes.func,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  footerRenderer: PropTypes.func,
  headerRenderer: PropTypes.func,
  triggerElementRenderer: PropTypes.func.isRequired,
  placement: PropTypes.string,
  width: PropTypes.number,
}
